import { cn } from "@components/ui/lib/utils"
import { type TInfoSectionProps, type TSectionAction } from "./types"
import { useDrawer } from "@contexts/DrawerContext"
import { renderSkeletonGroups } from "@utils/renderSkeletonGroups"
import { useHasPermissions } from "@hooks/useHasPermissions"

export const InfoSection = ({
  title,
  actions = [],
  description_lines,
  isPending = false,
  classNames,
}: TInfoSectionProps) => {
  const { openDrawer } = useDrawer()
  const allPermissions = useHasPermissions()

  const handleActionClick = (action: TSectionAction) => {
    if (action.displayedContent) {
      openDrawer(action.displayedContent, action.displayedTitle)
    } else {
      action.onClick?.()
    }
  }

  return (
    <div className={cn("tw:flex tw:flex-col tw:gap-2", classNames)}>
      <div className="tw:flex tw:items-center tw:gap-2">
        <h2 className="tw:mb-0 tw:text-sm tw:font-semibold">{title}</h2>
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={() => handleActionClick(action)}
            aria-label={action.ariaLabel || `Action ${index + 1}`}
            className={cn(
              "hover:tw:bg-gray-100 tw:rounded tw:border tw:border-gray-300 tw:p-1 tw:disabled:bg-gray-300",
              {
                "tw:hidden":
                  action.permission && !allPermissions[action.permission],
              },
            )}
          >
            {action.icon}
          </button>
        ))}
      </div>
      <div className="tw:flex tw:flex-col tw:gap-1 tw:text-xs">
        {isPending
          ? renderSkeletonGroups([{ count: 4, height: "tw:h-5" }])
          : description_lines.length
            ? description_lines.map((line, index) => (
                <p key={index} className={`tw:mb-0! ${line.className}`}>
                  {line.content}
                </p>
              ))
            : "N/A"}
      </div>
    </div>
  )
}
